import { render, staticRenderFns } from "./SkuRewardsTipsOrder.vue?vue&type=template&id=81887830&scoped=true&"
import script from "./SkuRewardsTipsOrder.vue?vue&type=script&lang=js&"
export * from "./SkuRewardsTipsOrder.vue?vue&type=script&lang=js&"
import style0 from "./SkuRewardsTipsOrder.vue?vue&type=style&index=0&id=81887830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81887830",
  null
  
)

export default component.exports